import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import ExpandMenu from '../../../../assets/data/expanded-menu.json'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { RegisterMixtapeService } from '@shared/services/register-mixpanel/register-mixtape.service';
import { cloneDeep } from 'lodash';
import { TooltipModule } from 'primeng/tooltip';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { FieldTypeSwitchComponent } from '../../../shared/components/field-type-switch/field-type-switch.component';
import { FieldTypeTextSimpleComponent } from '../../../shared/components/field-type-text/field-type-text-simple/field-type-text-simple.component';
import { FieldTypeListExtendedComponent } from '../../../shared/components/field-type-list-extended/field-type-list-extended.component';
import { FieldTypeColorComponent } from '../../../shared/components/field-type-color/field-type-color.component';
import { FieldTypeLogoComponent } from '../../../shared/components/field-type-logo/field-type-logo.component';
import { FormsModule } from '@angular/forms';
import { WizardStepsComponent } from '../../../shared/components/wizard-steps/wizard-steps.component';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { FieldTypeRichTextEditableComponent } from "../../../shared/components/field-type-rich-text/field-type-rich-text-editable/field-type-rich-text-editable.component";
import { ButtonWithTextMenuComponent } from "../../../shared/components/button-with-text-menu/button-with-text-menu.component";
import { ConceptUtilsService } from '@shared/services/concept-utils/concept-utils.service';
import { MultilanguageService } from '@shared/services/multilanguage-service/multilanguage.service';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";

@Component({
  selector: 'public-link-poll',
  templateUrl: './public-link-poll.component.html',
  standalone: true,
  imports: [
  NgClass,
  AfTranslateDirective,
  TooltipModule,
  WizardStepsComponent,
  FormsModule,
  FieldTypeLogoComponent,
  FieldTypeColorComponent,
  FieldTypeListExtendedComponent,
  FieldTypeTextSimpleComponent,
  FieldTypeSwitchComponent,
  AfTranslatePipe,
  FieldTypeRichTextEditableComponent,
  ButtonWithTextMenuComponent,
  OverlayPanelModule,
  SpanTooltipComponent
]
})
export class PublicLinkPollComponent implements OnInit {
  openLanguagesDropdown: boolean = false;
  evaluationId: string = this.route.snapshot.params['evaluationId'];
  concept: any = this.dialogConfig.data.concept;
  evaluationInfo: any = this.dialogConfig.data.evaluationInfo;
  publicLinkPoll: any ={
    stepState: 1,
    infoCustomizationPreview: '',
    showInfo: false,
    companyCopy: null,
    globalConfiguration: null,
    shareUrlItem: {expandedMenu: ExpandMenu['menuShareUrl'].menu},
    company: {
      corporativeInformation: {
        color: '',
        youtube: '',
        twitter: '',
        facebook: '',
        linkedin: '',
        instagram: '',
        phone:'',
        footer: ''
      },
      logo: '',
      name: '',
      logoFile: null
    },
    commentField: {
      label: this.translate.instant('corporative-information-modal.placeholder'),
      toolbar: 'bold italic underline forecolor backcolor alignleft aligncenter alignright link unlink',
    },
    clientFavicon: {
      label: this.translate.instant('corporative-information-modal.favicon-label'),
      description: this.translate.instant('corporative-information-modal.favicon-description'),
      accept:'.png,.ico,.jpg,.jpeg'
    },
    footerDesignType: {
      multiple: false,
      required: true,
      type: 'modal',
      label: this.translate.instant('global-customization.design-footer'),
      hideSearch: true
    },
    color: {
      label: this.translate.instant('global-customization.principal-color'),
      description: this.translate.instant('corporative-information-modal.info-primary-color'),
      required: true
    },
    textColor: {
      label: this.translate.instant('global-customization.secondary-color'),
      description: this.translate.instant('corporative-information-modal.info-secondary-color')
    },
    youtubeLink: {
      label: this.translate.instant('rrss.youtube'),
      specialIcon: 'lf-icon-youtube-round'
    },
    twitterLink: {
      label: this.translate.instant('rrss.twitter-x'),
      specialIcon: 'lf-icon-twitter-round'
    },
    facebookLink: {
      label: this.translate.instant('rrss.facebook'),
      specialIcon: 'lf-icon-facebook-round'
    },
    linkedinLink: {
      label: this.translate.instant('rrss.linkedin'),
      specialIcon: 'lf-icon-linkedin-round'
    },
    instagramLink: {
      label: this.translate.instant('rrss.instagram'),
      specialIcon: 'lf-icon-instagram-round'
    },
    clientLogo:{
      label: this.translate.instant('corporative-information-modal.logo'),
      required: true,
      exist: false
    },
    phoneReference: {
      label: this.translate.instant('global-customization.reference-phone'),
      fieldTypeId: 'num'
    },
    footerDesignTypeList: [
      {
        text: this.translate.instant('global-customization.footer-background-white'),
        listValueId: 1
      },
      {
        text: this.translate.instant('global-customization.footer-background-black'),
        listValueId: 2
      },
      {
        text: this.translate.instant('global-customization.footer-color-principal'),
        listValueId: 3
      }
    ],
    steps: [
      { name:this.translate.instant('corporative-information-modal.wizard-step-1')},
      { name: this.translate.instant('corporative-information-modal.wizard-step-2')}
    ],
    linkPollLanguagesSelected:[],
    linkPollLanguagesApp: [],
    linkPollDataTreatmentText: '',
    linkPollDataTreatment: {
      fieldId: 'global-configuration-data-treatment',
      fieldTypeId: 'rich',
      isEditable: true,
      label: this.translate.instant('corporative-information-modal.footer-description')
    }
  }
  constructor(private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService,
    private context: ContextFactory,
    private loader: LoaderFactory,
    private route: ActivatedRoute,
    private registerService: RegisterMixtapeService,
    private dateConverterService : DateConverterService,
    private modalService: ModalServiceService,
    private conceptUtilsService: ConceptUtilsService,
    private dialogRef: DynamicDialogRef<PublicLinkPollComponent>,
    private dialogConfig: DynamicDialogConfig,
    private multilanguageService: MultilanguageService) { }
  @ViewChild(ButtonWithTextMenuComponent) buttonWithTextMenu: ButtonWithTextMenuComponent;

  ngOnInit(): void {
    this.publicLinkPoll.published = this.concept.publicShared;
    // _getGlobalConfiguration();
    this.getCorporativeInformation();
    this.getUrlPublic();
  }

  getCorporativeInformation(){
    this.apiService.get('publicconceptcfg', 'concept/' + this.concept.conceptId)
      .then((data:any)=>{
        if(data){
          data.footerDesignType = !data.footerDesignType? 3 : data.footerDesignType;
          let isGlobalCfg: boolean = data.companyId?true:false;
          this.getGlobalConfiguration(isGlobalCfg);
          if(!isGlobalCfg){
            this.fillSetCorporativeInformation(data);
          }
          // Al obtener los logos, los obtiene de la configuración que este aplicando
          this.publicLinkPoll.company.allLogos = this.configureLogos(data);
          this.publicLinkPoll.company.logo = this.publicLinkPoll.company.allLogos;
          this.publicLinkPoll.company.logoFile = this.convertToFormData(this.publicLinkPoll.company.allLogos);
          this.publicLinkPoll.company.faviconImg = this.commonUtilsService.setLogo(data.favIcon, data.favIcon);
          this.publicLinkPoll.company.faviconFile = this.conceptUtilsService.convertToFormDataFavicon(this.publicLinkPoll.company.faviconImg);
          this.publicLinkPoll.company.sharedPublicConceptConfigurationId = data.sharedPublicConceptConfigurationId
          this.publicLinkPoll.companyCopy = cloneDeep(this.publicLinkPoll.company);
          this.getFooterTranslates()
        }else{
          // es nuevo y no tiene ninguna configuración, ni global ni específica
          this.getLogo();
        }
      }, (errorData:any)=> {
        this.handleDismiss('closeError');
      });
  }

  getGlobalConfiguration(isGlobalCfg: boolean = false){
    this.apiService.get('company','globalcustomization/'+this.context.user.companyId)
      .then((data:any)=>{
        this.publicLinkPoll.globalConfiguration = data;
        if(isGlobalCfg){
          this.fillSetCorporativeInformation(data);
        }
      },function(errorData){
          console.log(errorData);
      });
  }

  getFooterTranslates() {
    let that: any = this.publicLinkPoll
    this.apiService.get(`publicconceptcfg/${that.company.sharedPublicConceptConfigurationId}`, 'footers')
      .then((data: any) => {
        if (!this.multilanguageService.listHasDefaultLanguage(data)) {
          this.multilanguageService.addDefaultLanguage(data, that.company.sharedPublicConceptConfigurationId)
        }
        let configuration: any = this.multilanguageService.setListLanguages(data)
        that.linkPollLanguagesSelected = configuration.languagesSelected,
          that.linkPollLanguagesApp = configuration.appLanguages,
          that.linkPollDataTreatmentText = configuration.languageSelected.textDescription
      }, (errorData) => { })
  }

  fillSetCorporativeInformation(data:any){
    this.publicLinkPoll.company.faviconImg = this.commonUtilsService.setLogo(data.favIcon, data.favIcon);
    this.publicLinkPoll.company.faviconFile = this.conceptUtilsService.convertToFormDataFavicon(this.publicLinkPoll.companyfaviconImg);
    this.publicLinkPoll.company.corporativeInformation = {
        color: data.color,
        textColor: data.textColor,
        footerDesignType: data.footerDesignType,
        youtube: data.youtube,
        twitter: data.twitter,
        facebook: data.facebook,
        linkedin: data.linkedin,
        instagram: data.instagram,
        phone: data.phone,
        conceptId: this.concept.conceptId,
        footer: data.footer,
        showLogoInFooter: data.showLogoInFooter,
        sharedPublicConceptConfigurationId: data.sharedPublicConceptConfigurationId,
        global: (data.companyId !==null),
    };
    this.publicLinkPoll.infoCustomizationPreview = data?.companyId?'global':'customized';
    this.publicLinkPoll.companyCopy = cloneDeep(this.publicLinkPoll.company);
  }

  configureLogos(data:any){
    return {
        logo: this.commonUtilsService.setLogo(data.logo, data.logo),
        logo320X55: this.commonUtilsService.setLogo(data.logoFooter, data.logo),
        logo260X45: this.commonUtilsService.setLogo(data.logoHeader, data.logo),
        logo290X50: this.commonUtilsService.setLogo(data.logoOther, data.logo)
    }
  }

  convertToFormData(logos:any) {
    let fd = new FormData();
    let logo = this.commonUtilsService.baseToFormdata(logos.logo);
    let logo320X55 = this.commonUtilsService.baseToFormdata(logos.logo320X55);
    let logo260X45 = this.commonUtilsService.baseToFormdata(logos.logo260X45);
    let logo290X50 = this.commonUtilsService.baseToFormdata(logos.logo290X50);
    fd.append('file', logo);
    fd.append('file', logo320X55);
    fd.append('file', logo260X45);
    fd.append('file', logo290X50);
    return fd;
  }

  getLogo(){
    this.apiService.get('clients', this.evaluationInfo.clientId)
      .then((data:any)=>{
        if(data.logo !==''){
          this.publicLinkPoll.company.allLogos = {
            logo: this.commonUtilsService.setLogo(data.logo, data.logo),
            logo320X55: this.commonUtilsService.setLogo(data.logo320X55,data.logo),
            logo260X45: this.commonUtilsService.setLogo(data.logo260X45,data.logo),
            logo290X50: this.commonUtilsService.setLogo(data.logo290X50,data.logo)
          }
          this.publicLinkPoll.company.logo = this.publicLinkPoll.company.allLogos.logo;
          this.publicLinkPoll.company.logoFile = this.convertToFormData(this.publicLinkPoll.company.allLogos);
          this.publicLinkPoll.company.name = '';
          this.publicLinkPoll.companyCopy = cloneDeep(this.publicLinkPoll.company);
        }
        this.fillSetCorporativeInformation(data);
      }, function(errorData){})
  }

  getUrlPublic(){
    this.apiService.get('concepts/publicurl', this.concept.conceptId)
      .then((data:any)=>{
        this.concept.url = data;
      }, (errorData:any)=>{
        this.concept.url = "";
        this.handleDismiss('closeError');
      })
  }

  savePoll(){
    if(this.publicLinkPoll.modify){
      this.configureCorporativeInformation();
    }else{
      this.handleAccept();
    }
    this.getFooterMultilanguage();
    this.updateCorporativeMultilanguage(this.publicLinkPoll.company.corporativeInformation.sharedPublicConceptConfigurationId)
  }

  configureCorporativeInformation(){
    this.loader.openLoader('folder-share-public-poll');
    let companyInformation: any = this.publicLinkPoll.company.corporativeInformation;
    if(this.changesInCorprativeInformation()){
      if(companyInformation.global){
        this.addCorporativeInfo();
      }else{
        companyInformation.sharedPublicConceptConfigurationId? this.updateCorporativeInfo() :this.addCorporativeInfo();
      }
    }else{
      this.changePublicShared(!(this.publicLinkPoll.published));
    }
  }

  changesInCorprativeInformation(){
    let companyCopy: any = this.publicLinkPoll.companyCopy;
    let company: any = this.publicLinkPoll.company
    if(companyCopy && company){
      for(let property in companyCopy.corporativeInformation){
        if(companyCopy.corporativeInformation[property] !== company.corporativeInformation[property]){
          return true;
        }
      }
      for(let property in companyCopy.allLogos){
        if(companyCopy.allLogos[property] !== company.allLogos[property]){
          return true;
        }
      }
      if(companyCopy.faviconImg !== company.faviconImg){
        return true;
      }
    }else if(!companyCopy){
      return true;
    }
    return false;
  }

  addCorporativeInfo(){
    this.apiService.add('publicconceptcfg', this.publicLinkPoll.company.corporativeInformation)
      .then((data:any)=>{
        if (data !== null && data !== '') {
          this.publicLinkPoll.company.corporativeInformation.sharedPublicConceptConfigurationId = data.sharedPublicConceptConfigurationId;
          this.addLogoToCorporativeInformation(!this.publicLinkPoll.published);
        }else{
          this.changePublicShared(false);
        }
        this.configureFaviconCalls();
      },  ()=>{
        this.loader.closeError();
      })
  }

  configureFaviconCalls(){
    if(this.publicLinkPoll.company.faviconFile){
      this.addFaviconToCorporativeInformation();
    }else{
      this.removeFavicon();
    }
  }

  removeFavicon(){
    this.apiService.patch('company/removefaviconbyconceptid', this.concept.conceptId )
      .then((data:any) => {
      }, (errorData:any)=>{
        this.loader.closeError();
      });
  }

  addLogoToCorporativeInformation(newPoll:boolean = false){
    let sharedConfigurationId: any = this.publicLinkPoll.company.corporativeInformation.sharedPublicConceptConfigurationId
    this.apiService.attachFilePatch('publicconceptcfg/'+ sharedConfigurationId+'/logos', this.publicLinkPoll.company.logoFile)
      .then((data:any)=>{
        if(newPoll){
          this.changePublicShared(true);
        }else{
          this.loader.closeLoader('folder-share-public-poll');
          this.handleAccept();
        }
      }, (errorData:any)=>{
        this.loader.closeError();
        this.changePublicShared(false);
      });
  }

  changePublicShared(publicSharedStatus:boolean, unpublish:string = '') {
    this.loader.openLoader('folder-public-shared');
    this.apiService.patch('concepts/' + this.evaluationInfo.evaluationId + '/' + this.concept.conceptId + '/setpublic/' + publicSharedStatus)
      .then((data:any)=> {
        this.publicLinkPoll.published = publicSharedStatus;
        this.concept.publicShared = publicSharedStatus;
        if(this.publicLinkPoll.published){
          this.handleAccept('publish');
        }
        if(unpublish === 'unpublish'){
          this.publicLinkPoll.published = false;
          this.handleDismiss('unpublish');
        }
        this.loader.closeLoader(['folder-public-shared','folder-share-public-poll' ]);
      },  ()=>{
        this.loader.closeError();
      })
  }

  addFaviconToCorporativeInformation(){
    let configurationId: any = this.publicLinkPoll.company.corporativeInformation.sharedPublicConceptConfigurationId
    this.apiService.attachFilePatch('publicconceptcfg/'+ configurationId+'/favicon', this.publicLinkPoll.company.faviconFile)
      .then(()=>{}, ()=>{});
  }

  updateCorporativeInfo(){
    this.apiService.update('publicconceptcfg', undefined, this.publicLinkPoll.company.corporativeInformation)
      .then((data:any)=> {
        data !== null && data !== ''? this.addLogoToCorporativeInformation(): this.changePublicShared(false);
        this.configureFaviconCalls();
      }, ()=>{
        this.loader.closeError();
      })
  }

  getFooterMultilanguage(){
    let configuration: any = this.multilanguageService.checkLanguages(this.publicLinkPoll, false, 'linkPoll')
    this.publicLinkPoll.listSelectedLanguages = configuration.listSelectedLanguages;
  }

  updateCorporativeMultilanguage(sharedPublicConceptConfigurationId:any){
    this.setSharedPublicConcept(sharedPublicConceptConfigurationId)
    this.apiService.update(`publicconceptcfg/${sharedPublicConceptConfigurationId}`,'footers', this.publicLinkPoll.listSelectedLanguages)
    .then((data:any)=>{},(errorData:any)=>{})
  }

  setSharedPublicConcept(sharedPublicConceptConfigurationId:any){
    this.publicLinkPoll.listSelectedLanguages.forEach((item:any) => {
      item.sharedPublicConceptConfigurationId = sharedPublicConceptConfigurationId
    });
  }

  unpublishPoll(){
    this.changePublicShared(false, 'unpublish');
  }

  publishPoll(){
    if(this.publicLinkPoll.published){
      this.savePoll();
    }else {
      this.getFooterMultilanguage();
      this.saveConcept();
      let resgisterItem:any ={
        event: 'publish public link',
        conceptName:sessionStorage.getItem('breadcrumbConcept') + this.concept.title
      }
      this.registerService.register(resgisterItem);
    }
  }

  saveConcept(){
    this.concept.pollBeginDate = this.dateConverterService.toIso(new Date());
    this.apiService.patch('concepts/'+this.evaluationInfo.evaluationId, this.concept.conceptId, this.concept)
    .then((data:any)=>{
      this.configureCorporativeInformation();
      if(data?.sharedPublicConceptConfigurationId){
        this.updateCorporativeMultilanguage(data.sharedPublicConceptConfigurationId)
      }
    }, (error:any)=>{
      this.loader.closeError();
    })
  }

  itemSelectedOn(event:any, type:string){
    let newValue:any = event.newValue;
    this.itemSelected(type, newValue)
  }

  itemSelected(type:string, newValue:any){
    let corporativeInformation: any = this.publicLinkPoll.company.corporativeInformation;
    switch(type){
      case 'color':
      case 'textColor':
        corporativeInformation[type] = newValue;
        if(corporativeInformation[type] !== '' || corporativeInformation[type] !== null){
          this.publicLinkPoll[type].error = false;
        }
        break;
      case 'logo':
        if(newValue){
          this.commonUtilsService.setLogo(newValue.img, newValue.img);
          this.publicLinkPoll.company.listLogos = newValue.listLogos;
          this.publicLinkPoll.company.logo = newValue.img;
          this.publicLinkPoll.company.name =  newValue.name;
          this.publicLinkPoll.company.logoFile = newValue.files;
          this.publicLinkPoll.company.allLogos ={
            logo:newValue.listLogos[0].html.toDataURL('image/png'),
            logo320X55: newValue.listLogos[2].html.toDataURL('image/png'),
            logo260X45: newValue.listLogos[3].html.toDataURL('image/png'),
            logo290X50: newValue.listLogos[1].html.toDataURL('image/png'),
          }
        }else{
          delete this.publicLinkPoll.company.logo;
          delete this.publicLinkPoll.company.name;
          delete this.publicLinkPoll.company.logoFile;
          delete this.publicLinkPoll.company.listLogos;
          delete this.publicLinkPoll.allLogos;
        }
        break;
      case 'favicon':
        if(newValue){
          this.publicLinkPoll.company.faviconName = newValue.name;
          this.publicLinkPoll.company.faviconImg = newValue.img;
          this.publicLinkPoll.company.faviconFile = newValue.file;
        }else{
          delete this.publicLinkPoll.company.faviconName;
          delete this.publicLinkPoll.company.faviconImg;
          delete this.publicLinkPoll.company.faviconFile;
        }
        break;
      case 'youtube':
      case 'twitter':
      case 'facebook':
      case 'linkedin':
      case 'instagram':
      case 'phone':
      case 'showLogoInFooter':
        corporativeInformation[type] = newValue;
        this.publicLinkPoll.modify = this.changesInCorprativeInformation();
        break;
      case 'footer':
        let message = cloneDeep(this.commonUtilsService.extractInnerHTML(newValue));
        if(message) {
          corporativeInformation.footer = newValue;
        }
        this.publicLinkPoll.modify = this.changesInCorprativeInformation();
        break;
      default:
        corporativeInformation[type] = newValue;
        break;
    }
  }

  glConfig(){
    this.modalService.infoModal({ text: this.translate.instant('corporative-information-modal.global-question-unique'), typeButtons:'cancelContinue' })
      .subscribe((result:any) => {
        if(result.result === 'ok'){
          this.deleteConfig();
        }
      });
  }

  deleteConfig(){
    let sharedConfiguration: any = this.publicLinkPoll.company.corporativeInformation.sharedPublicConceptConfigurationId
    this.apiService.delete('publicconceptcfg', sharedConfiguration)
    .then((data:any)=>{
      this.publicLinkPoll.published? this.handleAccept(): this.getGlobalConfiguration(true);
    },(error:any)=>{})
  }

  nextStep(){
    if(this.validateFieldStep(this.publicLinkPoll.stepState)){
      if(this.publicLinkPoll.stepState === 1){
        this.publicLinkPoll.modify = this.changesInCorprativeInformation();
      }
      this.publicLinkPoll.stepState++;
    }
  }

  validateFieldStep(step:any){
    let corporative: any = this.publicLinkPoll.company.corporativeInformation;
    switch(step){
      case 1:
        this.publicLinkPoll.color.error = !(this.commonUtilsService.checkIsHexadecimalColor(corporative.color));
        this.publicLinkPoll.textColor.error = corporative.textColor && !(this.commonUtilsService.checkIsHexadecimalColor(corporative.textColor));
        this.publicLinkPoll.footerDesignType.error = (!corporative.footerDesignType);
        this.publicLinkPoll.clientLogo.error = Boolean(!this.publicLinkPoll.company.logo);
        return !(this.publicLinkPoll.color.error || this.publicLinkPoll.textColor.error || this.publicLinkPoll.footerDesignType.error || this.publicLinkPoll.clientLogo.error)
      default:
        return false;
    }
  }

  launchActionLink(option: any){
    let configuration: any = {
      evaluationId: this.evaluationInfo.evaluationId,
      conceptId: this.concept.conceptId,
      text: this.concept.url,
      action: option.action,
      buttonCopyTooltip: this.buttonWithTextMenu,
      typeButtonTooltip: 'buttonWithTextMenu',
      time: 2000
    }
    this.conceptUtilsService.selectOptionsLink(configuration);
  }

  changeActiveLanguagesSelected(selectedLanguage:any, addSelected?:any){
    this.multilanguageService.changeActiveLanguagesSelected(selectedLanguage, addSelected, this.publicLinkPoll, 'linkPoll')
  }

  removeActiveLanguage(selectedLanguage:any){
    this.multilanguageService.removeActiveLanguage(selectedLanguage, this.publicLinkPoll, 'linkPoll');
  }

  selectLanguage(selectedLanguage:any, dropdown:any){
    this.multilanguageService.selectLanguage(selectedLanguage, this.publicLinkPoll, 'linkPoll')
    dropdown.hide()
  }

  notSelectLanguage(language:any){
    return this.multilanguageService.notSelectLanguage(language, this.publicLinkPoll, 'linkPoll')
  }

  checkSelectedTab(){
    let that = this.publicLinkPoll;
    if(!Boolean(that.linkPollLanguagesSelected.filter((languageSelected:any)=>{ return languageSelected.active}).length)){
      that.linkPollLanguagesSelected[0].active = true;
    };

  }

  handleAccept(type:any = 'save') {
    this.dialogRef.close({
      result: 'ok',
      type: type
    })
  }

  handleDismiss(close:string = '') {
    this.dialogRef.close({close: close});
  }
}
